import React from 'react';
import { Modal, ModalSize } from 'components/modal/Modal';
import { Accordion } from 'features/product/components/Accordion';
import DollarCircle from 'media/images/dollar-circle.svg';
import { createStyles } from 'utils/createStyle';
import { colors } from 'styles/settings';
import { FAQsData } from 'common/modules/online-shopping-faqs';

export interface OnlineHistoryFAQProps {
    modalOpen: boolean;
    setModalOpen: (isOpen: boolean) => void;
}

const styles = createStyles({
    modalTop: ['flex flex-col justify-center items-center'],
    modalIcon: [{ width: '60px', height: '60px' }],
    modalTitle: ['mt-8 mb-4 font-semibold text-24px center text-brand-dark'],
    modalCopy: [
        'text-center text-16px',
        { color: colors.darkestGrey, lineHeight: '24px', paddingBottom: '22px' },
    ],
    modalSubheader: ['text-brand-dark text-18px mb-2 font-semibold', { marginTop: '40px' }],
    modalAccordianTitle: ['text-grey hover:underline'],
    modalAccordianContent: ['p-3'],
    modalAccordianContentParagraph: ['w-full text-sm mt-1 text-grey-1 font-normal'],
});

export const OnlineHistoryFAQ = (props: OnlineHistoryFAQProps) => {
    const items = FAQsData.map((item) => {
        return item;
    });

    return (
        <Modal
            title=""
            isOpen={props.modalOpen}
            onClose={() => props.setModalOpen(false)}
            showCloseButton={true}
            size={[ModalSize.MEDIUM, ModalSize.MEDIUM]}
        >
            <>
                <div className={styles.modalTop}>
                    <img className={styles.modalIcon} src={DollarCircle} alt="Dollar sign" />

                    <h3 className={styles.modalTitle}>Online Order History</h3>

                    <p className={styles.modalCopy}>
                        Online earnings automatically display with an 'Earn by' date, which is when
                        the brand confirms that you've made a purchase.
                    </p>

                    <p className={styles.modalCopy}>
                        If you made a purchase and do not see your earnings by the ‘Earn by’ date,
                        tap the ‘Claim’ button to request your earnings.
                    </p>
                </div>

                <h4 className={styles.modalSubheader}>FAQs</h4>

                <Accordion
                    multipleEntriesOpen
                    items={items.map((item) => {
                        return {
                            title: (
                                <>
                                    <div className={styles.modalAccordianTitle}>
                                        {item.question}
                                    </div>
                                </>
                            ),
                            value: item.question.trim(),
                            content: (
                                <>
                                    <div className={styles.modalAccordianContent}>
                                        {item.answer.map((answer) => (
                                            <p
                                                className={styles.modalAccordianContentParagraph}
                                                key={answer}
                                            >
                                                {answer}
                                            </p>
                                        ))}
                                    </div>
                                </>
                            ),
                        };
                    })}
                />
            </>
        </Modal>
    );
};
